<template>
  <div class="home">
    <el-container style="height: 100%">
      <el-aside width="240px">
        <aside-menu></aside-menu>
      </el-aside>
      <el-container>
        <!-- 头 -->
        <el-header>
          <header-control></header-control>
        </el-header>
        <!-- 主体 -->
        <el-main>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import asideMenu from '@/components/AsideMenu.vue';
import headerControl from '@/components/HeaderControl.vue'
export default {
  name: 'Home',
  components: {
    asideMenu,
    headerControl,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.home{
  width: 100%;
  height: 100vh;
}
.el-header{
  padding: 0;
  margin: 0;
}
</style>
